export const getBidLandscapeStyle = (palette = {}) => ({
  '.popup-dialog': {
    left: '0',
    right: '0',
    top: '0',
    bottom: '0',
    margin: 'auto',
    position: 'absolute',
    width: 1100,
    height: '600px !important',
    backgroundColor: 'transparent',
  },
  '.popup-container': {
    backgroundColor: 'rgba(255,255,255,0.5) !important',
    '& .bid-landscape.panel-form': {
      backgroundColor: 'white',
      border: '1px solid #BBB',
      boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)',
    },
  },

  '.bidlandscape-title': {
    fontSize: 20,
    marginTop: 6,
    marginLeft: -15,
    marginBottom: 15,
    display: 'block',
    fontWeight: 600,
  },
  '.bidlandscape-subTitle': {
    marginBottom: '15px',
  },
  '.bidlandscape-subTitle .fwLink': {
    marginLeft: '5px',
  },
  '.bid-landscape': {
    padding: 16,
    fontSize: 14,
    color: '#323130',
  },
  '.bidlandscape-detail-table': {
    width: '100%',
  },
  '.bid-landscape__radio': {
    position: 'relative',
  },
  'tr.bidlandscape-table-row.cursor-pointer': {
    float: 'inherit',
  },
  'col.bid-landscape__col.bid-landscape__col--bid': {
    width: 130,
  },
  'col.bid-landscape__col.bid-landscape__col--radio': {
    width: 46,
  },
  'col.bid-landscape__col.bid-landscape__col--bi': {
    width: 130,
  },
  '.bidlandscape-table-row td:nth-child(1)': {
    textAlign: 'center',
  },
  '.clear': {
    clear: 'both',
  },
  '.radio-inline.adgroup-bid-update-clear-custom-bid-mode': {
    marginLeft: '0',
  },
  '.bidlandscape-data-panel .bidlandscape-left-div': {
    padding: '0',
    width: '62.666667%',
    marginLeft: 6,
  },
  '.bidlandscape-action input.btn.btn-primary': {
    marginRight: 8,
  },
  '.bidlandscape-chart': {
    width: 330,
    height: 210,
    padding: '0',
    marginTop: 43,
    overflow: 'visible !important',
    '& .highcharts-series-group': {
      '& .highcharts-line-series': {
        '& > path.highcharts-point': {
          opacity: '1 !important',
        },
      },
    },
  },
  '.bidlandscape-data-panel .error': {
    color: '#D90026',
    marginLeft: 42,
  },
  '.bidlandscape-right-div': {
    padding: '0',
    marginLeft: 20,
  },
  '.bidlandscape-table-row td': {
    paddingRight: 5,
    fontWeight: 'normal',
    lineHeight: '24px',
  },
  '.bidlandscape-table-row th': {
    verticalAlign: 'text-top',
    fontWeight: 600,
  },
  '.bidlandscape-table-row .bidlandscape-label': {
    whiteSpace: 'nowrap',
    overflowWrap: 'normal',
  },
  '.bidlandscape-footer-warning': {
    fontSize: 12,
    paddingTop: 10,
  },
  '.bidlandscape-footer.type-normal': {
    paddingTop: 46,
    fontSize: 12,
  },
  '.bidlandscape-action': {
    marginTop: 17,
    marginBottom: 8,
  },
  '.bid-current-row': {
    backgroundColor: '#F3F2F1',
  },
  '.bidlandscape-footer b': {
    fontWeight: 'normal',
  },
  '.bidlandscape-column .bidlandscape_icon': {
    position: 'static',
  },
  '.fix-dialog-position .modal-dialog': {
    width: 1100,
    maxWidth: 'unset',
  },
  '.campaign-bid-landscape': {
    padding: 0,
  },
  '.bidlandscape_icon.disabled': {
    color: 'rgba(50, 49, 48, 0.5)',
  },
  '.campaign-bid-landscape .bidlandscape-title': {
    marginLeft: 0,
  },
  '.campaign-bid-landscape .radio-inline': {
    display: 'block',
  },
  '.campaign-bid-landscape .radio-inline+.radio-inline': {
    marginLeft: 0,
  },
  '.fix-dialog-position .modal-body': {
    padding: '14px 24px 24px',
  },
  '.fix-dialog-position .modal-empty-header': {
    padding: 0,
  },
  '.bidlandscape-campaign-type': {
    lineHeight: '19px',
  },
  '.bidlandscape-campaign-type .title': {
    display: 'none',
  },
  '.campaign-bid-landscape .bidlandscape-data-panel': {
    marginTop: '15px',
    marginBottom: '15px',
  },
  '.campaign-bid-landscape col.bid-landscape__col.bid-landscape__col--bi': {
    width: 100,
  },
  '.campaign-bid-landscape .bid-landscape-input-group .bid-landscape__input': {
    outline: 'none',
    border: 'none',
    marginRight: 5,
  },
  '.campaign-bid-landscape .bid-landscape-input-group .bid-landscape__select': {
    outline: 'none',
    border: 'none',
  },
  '.campaign-bid-landscape .bid-landscape-input-group': {
    border: '1px solid #ccc',
    display: 'inline-block',
    backgroundColor: '#fff',
    lineHeight: '26px',
    padding: '0 5px',
  },
  '.campaign-bid-landscape .bidlandscape-campaign-additionalbudget': {
    margin: '15px 6px',
    padding: 10,
    border: `1px solid ${palette.neutralSecondary}`,
  },
  '.campaign-bid-landscape .bidlandscape-campaign-additionalbudget .title': {
    fontWeight: 600,
  },
  '.campaign-bid-landscape .bidlandscape-footer': {
    marginTop: 10,
    padding: 0,
  },
  '.campaign-bid-landscape .bidlandscape-chart': {
    marginTop: 0,
  },
  '.campaign-bid-landscape .highcharts-root,.campaign-bid-landscape .highcharts-container ': {
    overflow: 'visible!important',
  },
  '.type-normal': {
    fontWeight: 'normal!important',
  },
  '.campaign-bid-landscape td.selected,.campaign-bid-landscape th.selected': {
    backgroundColor: palette.neutralLighter,
  },
  '.campaign-bid-landscape tr.bid-current-row td': {
    backgroundColor: palette.themeLighter,
  },
  '.campaign-bid-landscape .bid-current-row td.selected': {
    backgroundColor: palette.themeLight,
  },
  '.campaign-bid-landscape .bidlandscape-table-row:hover td': {
    backgroundColor: palette.neutralLighter,
  },
});
